import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4aeda1e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Administrátor")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Executive")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Obchodník")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Uložit změny ")

import { computed, PropType, ref } from 'vue';
import { useStore } from 'vuex';
import { NSwitch, NButton, NDivider, useMessage } from 'naive-ui';
import BaseFlex from '@/components/layout/BaseFlex.vue';
import BaseSpinner from '@/components/ui/BaseSpinner.vue';
import { API } from '@/api';


export default /*#__PURE__*/_defineComponent({
  props: {
	userInfo: { type: Object as PropType<User>, required: true },
},
  setup(__props) {

const props = __props

const { getters, dispatch } = useStore();
const myInfo = computed(() => getters['auth/userInfo']);
const rights = computed(() => getters['auth/rights']);

const message = useMessage();
const pending = ref<boolean>(false);
const roles = ref<string[]>(props.userInfo.roles || []);

const toggleRole = (roleName: string): void => {
	const roleIndex = roles.value.indexOf(roleName);
	if (roleIndex === -1) {
		roles.value.push(roleName);
	} else {
		roles.value.splice(roleIndex, 1);
	}
	roles.value = roles.value.filter((role) => {
		if (roleName === 'admin' && ['admin', 'sales_person'].indexOf(role) === -1) {
			return false;
		}
		if (roleName === 'manager' && ['manager', 'sales_person'].indexOf(role) === -1) {
			return false;
		}
		return true;
	});
};

const saveRoles = async () => {
	pending.value = true;
	try {
		await API.users.setRoles(props.userInfo.id, roles.value);
		message.success('Role byly změněny');
		pending.value = false;
		await dispatch('users/fetchData', true);
		await dispatch('lists/fetchSalesPersons', true);
	} catch (error) {
		pending.value = false;
		const catchError: AjaxResponseDto = error as AjaxResponseDto;
		const { message: errorMessage } = catchError?.payload as MessageResponseDto;
		message.error(errorMessage || 'Neznámá chyba aktualizace rolí');
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseFlex, {
      row: "",
      "class-name": "py-xs",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(BaseFlex, {
          col: "",
          flex: [1, 1]
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(BaseFlex, {
          col: "",
          flex: [0, 0]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NSwitch), {
              disabled: !_unref(rights).admin || _unref(myInfo).id === __props.userInfo.id,
              "checked-value": true,
              "unchecked-value": false,
              value: roles.value.indexOf('admin') > -1,
              "onUpdate:value": _cache[0] || (_cache[0] = () => toggleRole('admin'))
            }, null, 8, ["disabled", "value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(BaseFlex, {
      row: "",
      "class-name": "py-xs",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(BaseFlex, {
          col: "",
          flex: [1, 1]
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(BaseFlex, {
          col: "",
          flex: [0, 0]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NSwitch), {
              disabled: !_unref(rights).admin || _unref(myInfo).id === __props.userInfo.id,
              "checked-value": true,
              "unchecked-value": false,
              value: roles.value.indexOf('manager') > -1,
              "onUpdate:value": _cache[1] || (_cache[1] = () => toggleRole('manager'))
            }, null, 8, ["disabled", "value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(NDivider)),
    _createVNode(BaseFlex, {
      row: "",
      "class-name": "py-xs",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(BaseFlex, {
          col: "",
          flex: [1, 1]
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(BaseFlex, {
          col: "",
          flex: [0, 0]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NSwitch), {
              disabled: !_unref(rights).admin,
              "checked-value": true,
              "unchecked-value": false,
              value: roles.value.indexOf('sales_person') > -1,
              "onUpdate:value": _cache[2] || (_cache[2] = () => toggleRole('sales_person'))
            }, null, 8, ["disabled", "value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createVNode(_unref(NButton), {
        size: "small",
        type: "success",
        secondary: "",
        disabled: !_unref(rights).admin,
        onClick: saveRoles
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    (pending.value)
      ? (_openBlock(), _createBlock(BaseSpinner, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})